import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { Formik, Form } from "formik";

import * as S from "./styles";

import EditNote from "../../assets/user/edit_note_black_24dp.svg";
import FowardInbox from "../../assets/user/forward_to_inbox_black_24dp.svg";
import logo from "../../assets/ATUAL APP - SIN_Sinosserra-branco.svg";

import BorderedInputText from "../../components/BorderedInputText";
import Button from "../../components/Button";
import Skeleton from "../../components/skeleton";

import api from "../../services/api";
import desmaskIfNumber from "../../utils/desmaskIfNumber";
import { mask, unMask } from "../../utils/mask";
import { Context } from "../../context/globalContext";

const SendSchema = Yup.object().shape({
  cpfCnpj: Yup.string().required("O campo deve ser Preenchido"),
  email: Yup.string().required("O campo deve ser Preenchido"),
});

export default function ForgotPassWord() {
  const { setIsLoading } = useContext(Context);
  const globalContext = useContext(Context);
  const [screenSwitch, setScreenSwitch] = useState(false);
  const [sent, setSent] = useState(false);
  const [userNotFound, setUserNotFound] = useState(false);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const response = await api.post(
        `api/recuperarSenha/usuario/recuperarSenha?email=${
          values.email
        }&cpfCnpj=${desmaskIfNumber(values.cpfCnpj)}`,
        null
      );
      if (response && response.status === 204) {
        setSent(true);
      } else if (!response) {
        setScreenSwitch(false);
      }
    } catch (err) {
      err?.response?.status === 500 && setScreenSwitch(false);
      err?.response?.status === 400 && setScreenSwitch(false);
      err?.response?.status === 404 && setScreenSwitch(false);
    } finally {
      setIsLoading(false);
      setScreenSwitch(true);
    }
  };

  return (
    <>
      <S.Topbar>
        <S.Image src={logo} />
      </S.Topbar>
      <S.Wrapper>
        <S.Header className="header">
          <S.BoxUser>
            <S.Image src={EditNote} />
            <div>
              <S.Title>Recuperação de senha</S.Title>
              <S.Description>
                Informe o seu CPF e e-mail para recuperarmos a sua senha
              </S.Description>
            </div>
          </S.BoxUser>
        </S.Header>
        {!screenSwitch ? (
          <S.Content>
            <Formik
              initialValues={{ cpfCnpj: "", email: "" }}
              validationSchema={SendSchema}
            >
              {({ errors, touched, values, setFieldValue }) => (
                <Form>
                  <S.InputBox>
                    {!globalContext.isLoading ? (
                      <BorderedInputText
                        type="text"
                        name="cpfCnpj"
                        label="CPF do usuário"
                        value={values.cpfCnpj}
                        error={errors.cpfCnpj}
                        onChange={(e) => {
                          setFieldValue(
                            "cpfCnpj",
                            mask(
                              unMask(e.target.value, "\\.|-"),
                              "###.###.###-##",
                              true
                            )
                          );
                        }}
                      />
                    ) : (
                      <S.SkeletonInput>
                        <Skeleton type="label" />
                        <Skeleton type="borderedInput" />
                      </S.SkeletonInput>
                    )}
                    {!globalContext.isLoading ? (
                      <BorderedInputText
                        type="text"
                        name="email"
                        label="E-mail cadastrado"
                        error={errors.email}
                        value={values.email}
                        onChange={(e) => {
                          setFieldValue("email", e.target.value);
                        }}
                      />
                    ) : (
                      <S.SkeletonInput>
                        <Skeleton type="label" />
                        <Skeleton type="borderedInput" />
                      </S.SkeletonInput>
                    )}
                  </S.InputBox>
                  <S.ButtonContainer>
                    <Button
                      button="primary"
                      type="button"
                      onClick={() => handleSubmit(values)}
                    >
                      Enviar
                    </Button>
                  </S.ButtonContainer>
                </Form>
              )}
            </Formik>
          </S.Content>
        ) : sent ? (
          <S.Content>
            <div className="imgWrapper">
              <S.Image src={FowardInbox} />
            </div>
            <S.SentText>
              <p>Verifique seu email cadastrado!</p>
              <p>
                Enviamos um link de acesso temporário para a recuperação da sua
                senha.
              </p>
            </S.SentText>
          </S.Content>
        ) : (
          <S.Content>
            <div className="imgWrapper">
              <S.Image src={FowardInbox} />
            </div>
            <S.SentText>
              <p>Usuário e/ou E-mail não encontrados.</p>
              <p>
                Caso você seja um colaborador Sinosserra, realize a troca de
                senha diretamente pela rede.
              </p>
            </S.SentText>
            <S.ButtonContainer>
              <Button
                button="primary"
                type="button"
                onClick={() => setScreenSwitch(false)}
              >
                Voltar
              </Button>
            </S.ButtonContainer>
          </S.Content>
        )}
      </S.Wrapper>
    </>
  );
}
